module.exports = __webpack_public_path__ + "static/media/1.298be1c9.jpg";